// extracted by mini-css-extract-plugin
export default {"wrap":"_F-z","fullWidth":"aG-z","hideOnDesktop":"bG-z","content":"cG-z","hasOpenedNav":"dG-z","crumbsList":"eG-z","dropdownsWrap":"fG-z"};